import { render, staticRenderFns } from "./DistanceModalCombo.vue?vue&type=template&id=1dec5d01&scoped=true&"
import script from "./DistanceModalCombo.vue?vue&type=script&lang=js&"
export * from "./DistanceModalCombo.vue?vue&type=script&lang=js&"
import style0 from "./DistanceModalCombo.vue?vue&type=style&index=0&id=1dec5d01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec5d01",
  null
  
)

export default component.exports